function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M0.625,0 L19.7411165,0 C19.9068768,2.18999637e-15 20.065848,0.065848025 20.1830583,0.183058262 L29.8169418,9.81694175 C29.934152,9.934152 30,10.0931232 30,10.2588835 L30,39.375 C30,39.7201779 29.7201779,40 29.375,40 L0.625,40 C0.279822031,40 4.22721094e-17,39.7201779 0,39.375 L0,0.625 C-4.22721094e-17,0.279822031 0.279822031,6.34081644e-17 0.625,0 Z",
  id: "path-1"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "presentation"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-14"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-13"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-12"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-11"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-10"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-9"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-8"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-4"
}, /*#__PURE__*/React.createElement("g", {
  id: "Mask",
  fill: "#EFF4F6",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0.625,0 L19.7411165,0 C19.9068768,2.18999637e-15 20.065848,0.065848025 20.1830583,0.183058262 L29.8169418,9.81694175 C29.934152,9.934152 30,10.0931232 30,10.2588835 L30,39.375 C30,39.7201779 29.7201779,40 29.375,40 L0.625,40 C0.279822031,40 4.22721094e-17,39.7201779 0,39.375 L0,0.625 C-4.22721094e-17,0.279822031 0.279822031,6.34081644e-17 0.625,0 Z",
  id: "path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "fold-Clipped"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "path-1"
}), /*#__PURE__*/React.createElement("rect", {
  id: "fold",
  fill: "#D5E1E5",
  fillRule: "nonzero",
  mask: "url(#mask-2)",
  x: 20,
  y: 0,
  width: 10,
  height: 10
})))))))))), /*#__PURE__*/React.createElement("g", {
  id: "board-29",
  transform: "translate(5.000000, 13.125000)",
  fill: "#637282",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.375,13.75 L0.625,13.75 C0.279375,13.75 0,14.03 0,14.375 C0,14.72 0.279375,15 0.625,15 L6.76625,15 L3.900625,18.343125 L4.849375,19.156875 L8.4125,15 L9.375,15 L9.375,18.75 L10.625,18.75 L10.625,15 L11.5875,15 L15.150625,19.156875 L16.099375,18.343125 L13.23375,15 L19.375,15 C19.720625,15 20,14.72 20,14.375 C20,14.03 19.720625,13.75 19.375,13.75 Z",
  id: "Shape"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.5,0 L2.5,0 C2.154375,0 1.875,0.28 1.875,0.625 L1.875,11.875 C1.875,12.22 2.154375,12.5 2.5,12.5 L17.5,12.5 C17.845625,12.5 18.125,12.22 18.125,11.875 L18.125,0.625 C18.125,0.28 17.845625,0 17.5,0 Z M10,9.375 C8.274375,9.375 6.875,7.975625 6.875,6.25 C6.875,4.524375 8.274375,3.125 10,3.125 L10,6.25 L13.125,6.25 C13.125,7.975625 11.725625,9.375 10,9.375 Z",
  id: "Shape"
}))));

var SvgPresentation = function SvgPresentation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "40px",
    viewBox: "0 0 30 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPresentation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/presentation.a5c644a0.svg";
export { ForwardRef as ReactComponent };